





















































import Vue from "vue";
import CreateAnimationViewModel from "@models/animations/createAnimationViewModel";
import { Component } from "vue-property-decorator";

@Component
export default class PageCreateAnimationComponent extends Vue {
  isLoading = false;
  get title(): string {
    return this.id ? "Редактирование анимации" : "Добавление анимации";
  }
  get id(): string {
    const routeId = this.$route.params.id;
    return routeId ? routeId : "";
  }
  vm: CreateAnimationViewModel = new CreateAnimationViewModel();
  async created() {
    if (this.$route.params.id) {
      await this.fetchData();
    }
  }
  async fetchData() {
    this.isLoading = true;
    this.$cacheProvider.getLanguagesAsync;
    const res = await this.$api.AnimationService.getAnimationsAsync();
    const current = res.find((x) => x.Id == this.id);
    this.vm.fromServerModel(current);
    this.isLoading = false;
  }
  async save() {
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    const request = this.vm.toServerModel();
    const res = await this.$api.AnimationService.updateAnimationAsync(request);
    if (res) {
      this.$dialog.success("Анимация успешно добавлена");
      this.$router.back();
    }
    this.isLoading = false;
  }
}
